interface HeaderHintMeta {
  headerHint: string;
}

export function toHeaderHintMeta(hint: string): HeaderHintMeta {
  return { headerHint: hint };
}

export function getHeaderHint(meta: unknown): string | undefined {
  if (typeof meta !== 'object' || meta === null || !('headerHint' in meta)) return undefined;
  return typeof meta.headerHint === 'string' ? meta.headerHint : undefined;
}
